var faviconsContext = require.context(
  '!!file-loader?name=assets/favicons/[name].[ext]!../../src/assets',
  true,
  /\.(svg|png|ico|xml|json)$/
)

faviconsContext.keys().forEach(faviconsContext)
